import { render, staticRenderFns } from "./PersonalDetails.vue?vue&type=template&id=44fb049d&scoped=true&"
import script from "./PersonalDetails.vue?vue&type=script&lang=js&"
export * from "./PersonalDetails.vue?vue&type=script&lang=js&"
import style0 from "./PersonalDetails.vue?vue&type=style&index=0&id=44fb049d&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "44fb049d",
  null
  
)

export default component.exports